import _ from 'lodash';
import * as fb from '../firebase';

export default {
  getRef(ingredientId) {
    return fb.ingredientsCollection.doc(ingredientId);
  },

  searchIngredients(text) {
    const bigChar = String.fromCharCode(20000);
    return fb.ingredientsCollection
      .where('validated', '==', true)
      .where('title', '>=', text)
      .where('title', '<', text + bigChar)
      .limit(10)
      .get()
      .then((res) => {
        return res.docs.map((ing) => {
          return { ref: ing.ref, ...ing.data() };
        });
      });
  },

  getNonValidatedIngredients() {
    return fb.ingredientsCollection
      .where('validated', '==', false)
      .get()
      .then((res) => {
        return res.docs.map((ing) => {
          return { ref: ing.ref, ...ing.data() };
        });
      });
  },

  /**
   * Modifie un ingrédient (title & validated)
   * @param {*} ingredientId
   * @param {String} title
   * @param {Boolean} validated
   */
  update(ingredientId, title = null, validated = null) {
    const data = {};
    if (title !== null) {
      data.title = title;
    }
    if (validated !== null) {
      data.validated = validated;
    }
    return fb.ingredientsCollection.doc(ingredientId).update(data);
  },

  /**
   *
   * @param {*} ingredientId
   */
  delete(ingredientId) {
    return fb.ingredientsCollection.doc(ingredientId).delete();
  },

  /**
   * Valide un ingrédient
   * @param {Ingredient} ingredient
   */
  validate(ingredient) {
    return this.update(ingredient.ref.id, null, true);
  },

  /**
   * Change un ingrédient par un autre dans tous les meals qui le contiennent.
   * @param {Ingredient} oldIngredient
   * @param {Ingredient} newIngredient
   */
  async updateIngredientInMeals(oldIngredient, newIngredient) {
    const dataToSearch = {
      ingredientRef: oldIngredient.ref,
      title: oldIngredient.title,
    };
    // modif partout où cet ingrédient est utilisé
    const mealsToUpdate = await fb.mealsCollection
      .where('ingredients', 'array-contains', dataToSearch)
      .get();

    if (mealsToUpdate.docs.length !== 1) {
      console.error(
        '[updateIngredientInMeals] - more than 1 meal with ingedient',
        oldIngredient.ref.id
      );
      return Promise.reject();
    }
    const mealToUpdate = mealsToUpdate.docs[0];
    if (mealToUpdate.exists) {
      // On modifie les ingredients du meal pour insérer le nouveau
      const mealIngredients = _.get(mealToUpdate.data(), 'ingredients', []);
      const ingIndexToChange = _.findIndex(
        mealIngredients,
        (ing) =>
          _.get(ing.ingredientRef, 'id', 0) ===
          _.get(oldIngredient.ref, 'id', 1)
      );
      mealIngredients[ingIndexToChange] = newIngredient;

      // Map pour que si ce faux ingrédient revient, on le remplace automatiquement
      await fb.ingredientMapIngredient.add({
        oldIngredientTitle: oldIngredient.title,
        newIngredientRef: newIngredient.ingredientRef,
      });

      return fb.mealsCollection
        .doc(mealToUpdate.ref.id)
        .update({ ingredients: mealIngredients });
    }
    console.error('meal does not exist');
    return Promise.reject();
  },

  /**
   * Renomme un ingrédient, et le modifie dans tous les meals où il est utilisé
   * @param {Ingredient} ingredient
   * @param {String} newTitle
   */
  async renameAndValidate(ingredient, newTitle) {
    await this.update(ingredient.ref.id, newTitle, true);
    const newIngredient = {
      ingredientRef: ingredient.ref,
      title: newTitle,
    };
    return this.updateIngredientInMeals(ingredient, newIngredient);
  },

  /**
   * Supprimer un ingrédient et le remplace par sa similarité partout.
   * @param {Ingredient} ingredient
   * @param {Ingredient} similarity
   */
  async mergeWithSimilarity(ingredient, similarity) {
    const newIngredient = {
      ingredientRef: similarity.ref,
      title: similarity.title,
    };
    await this.updateIngredientInMeals(ingredient, newIngredient);
    // Delete other ingredient
    return this.delete(ingredient.ref.id);
  },
};
